/**
 * Users service — per-user auth tokens.
 * Ported 1:1 from the legacy flat services/users.js; shapes verified against
 * docs/users-migration/Api-response/ (user-auth-token*.json).
 */
import constants from '../../constants'
import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'
import { ChatApp, AuthTokenResponse, AuthTokensListResponse } from './types'

export async function authTokenList(
  id: string,
  app: ChatApp,
  apiHost: string,
  pageNo = 1,
): Promise<AuthTokensListResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}/auth_tokens?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

/** Response `data.authToken` doubles as the delete id (verified capture). */
export async function authTokenAdd(
  uid: string,
  app: ChatApp,
  apiHost: string,
): Promise<AuthTokenResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/users/${uid}/auth_tokens`
  return axios
    .post(
      `${URL}`,
      { force: true },
      {
        headers: getChatApiHeaders(app),
      },
    )
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function authTokenDel(
  id: string,
  uid: string,
  app: ChatApp,
  apiHost: string,
): Promise<AuthTokenResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/users/${uid}/auth_tokens/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function authTokenSearch(
  uid: string,
  app: ChatApp,
  apiHost: string,
  searchText: string,
): Promise<AuthTokensListResponse> {
  const URL = `${getChatApiBase(
    app,
    apiHost,
  )}/users/${uid}/auth_tokens?searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}
